/* src/app/admin-dashboard/common-popup/common-popup.css */
.popup-header {
  background-color: var(--custom-color);
  color: white;
  height: 90px;
  width: "auto";
  font-size: 20px;
  padding: 30px;
}
::ng-deep .mat-mdc-dialog-container {
  padding-top: 0 !important;
  border-radius: 15px;
  margin-bottom: 10px !important;
}
::ng-deep common-popup.ng-star-inserted > div {
  margin-right: -0px;
  margin-left: -0px;
}
::ng-deep .mat-mdc-dialog-actions {
  margin-right: 5px !important;
  margin-left: 0 !important;
  margin-bottom: 2px !important;
}
.form-control-product {
  height: 50px;
  padding: 0px;
}
@media (min-width:629px) {
  .form-control::-webkit-input-placeholder {
    color: transparent;
  }
  .form-control:-moz-placeholder {
    color: transparent;
  }
  .form-control::-moz-placeholder {
    color: transparent;
  }
  .form-control :-ms-input-placeholder {
    color: transparent;
  }
}
@media (max-width:629px) {
  div.optionalstuff {
    display: none;
  }
}
.popup-check {
  display: flex;
  align-items: center;
  gap: 10px;
  margin: 0;
  padding: 4px 2px;
  cursor: pointer;
  width: 100%;
}
.popup-check input {
  width: 18px;
  height: 18px;
  margin: 0;
  flex: 0 0 auto;
}
.popup-hint {
  display: block;
  width: 100%;
  margin-top: 4px;
  font-size: 12px;
  color: #777;
}
/*# sourceMappingURL=common-popup.css.map */
